import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaIdCard } from "react-icons/fa6";
import EmployeeDetails from "./index";
import ViewProfileDetail from "./view";

const employeeDetailRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Details",
		basePath: "employee-details",
		mainComponent: <EmployeeDetails/>,
		layout: "/console",	   
		icon: <FaIdCard className="icon-item" />,
		subTitle:"Employee",
		viewComponent: <ViewProfileDetail />,
		level:5,
		moduleId: 0,
	})
]

export default employeeDetailRoutes;